import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, NavigationExtras } from '@angular/router';
import { Observable } from 'rxjs';
import { ServicioAuthService } from '../services/servicio-auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor( private authService: ServicioAuthService,
               private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const url = state.url;
    const codigoBaseDatos = next.params.codigoBaseDatos;
    const canActivate = this.authService.isLogin();
    if (!canActivate) {
      const obj: any = {
        'codigoBaseDatos' : codigoBaseDatos,
        'url' : url
      };
      sessionStorage.setItem('auth_reporte', JSON.stringify(obj));
      this.router.navigate(['/login']);
      return false;
    }
    return true;
  }
}
